import React from 'react';
import { Constants } from "@eagerdog/constants";

import Icon from "src/components/Icon/Icon";
import { Modal, useModal } from "src/components/Modal/Modal";

import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from "./CourseRegistrations.module.scss";

interface CustomTransactionCellRendererProps extends CustomCellRendererProps {
  onUpdateAttendance(status: string, registrationId: string): void
}

export const AttendanceRenderer = (props: CustomTransactionCellRendererProps) => {
  const { isShown, toggle } = useModal();

  return (<div className={styles.AttendanceRenderer}>
    <div className={styles.wrap}>
        <div className={styles.inner}>
            <div
              onClick={() => { props.onUpdateAttendance(Constants.course_session_attendance_status.present, props.value.registration._id) }}
              className={`${styles.present}
              ${props.value.registration.status === Constants.course_session_attendance_status.present ? styles.active : ''} `}>
                <Icon className={styles.smallCheck} type="check" />
            </div>
            <div
              onClick={() => { props.onUpdateAttendance(Constants.course_session_attendance_status.pending, props.value.registration._id) }}
              className={`${styles.pending} ${props.value.registration.status === Constants.course_session_attendance_status.pending ? styles.active : ''} `}>
                <span>/</span>
            </div>
            <div
              onClick={() => { props.onUpdateAttendance(Constants.course_session_attendance_status.absent, props.value.registration._id) }}
              className={`${styles.absent} ${props.value.registration.status === Constants.course_session_attendance_status.absent ? styles.active : ''} `}>
                <Icon className={styles.smallClose} type="close" />
            </div>
        </div>
    </div>
  </div>);
};
